import Toolbar from "@mui/material/Toolbar";
import {
  Avatar,
  Box,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import NavbarLogo from "../../../../assets/images/bot-logo.svg";
import Picture from "../../../../assets/images/picture.png";
import { useTheme } from "@mui/material/styles";
import "./index.css";
import { CustomButton } from "../../../../components/Button";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setUser } from "../../../../rtkSlices/metaDataSlice";
import { TfiHelpAlt } from "react-icons/tfi";
import { IoSettingsOutline } from "react-icons/io5";
import {
  RiClaudeFill,
  RiLogoutCircleRLine,
  RiOpenaiFill,
} from "react-icons/ri";
import { IoChatbubbleEllipsesOutline } from "react-icons/io5";
import ManageThread from "../../../chat/Chat/ManageThread";
import { FaRegTrashCan } from "react-icons/fa6";
import { useDeleteThreadMutation } from "../../../../services/chat";
import { ConfirmationDialog } from "../../../../components/ConfirmationDialog";
import { errorToast, successToast } from "../../../../utils/toast";
import { ReactComponent as DeepseekIcon } from "../../../../assets/images/deepseek.svg";
import { setConversations } from "../../../../rtkSlices/conversationsSlice";

export const SideDrawer = ({
  title,
  id,
  handleDrawerToggle,
}: {
  title?: string;
  id?: number;
  handleDrawerToggle: () => void;
}) => {
  const metaData = useSelector((state: any) => state.metaData, shallowEqual);
  const paymentLinks = metaData.stripe.paymentLinks;
  const conversations = useSelector(
    (state: any) =>
      state.conversations.conversations
        ? [...state.conversations.conversations].reverse()
        : [],
    shallowEqual
  );
  const {
    firstName,
    lastName,
    given_name,
    family_name,
    email,
    subscriptionStatus,
    personalThread,
    personal_thread_id,
    personal_thread_llm,
  } = metaData.userInfo;
  const username = firstName
    ? `${firstName} ${lastName}`
    : given_name
    ? `${given_name} ${family_name}`
    : "";
  const navigate = useNavigate();
  const [selectedConversation, setSelectedConversation] = useState("");
  const dispatch = useDispatch();
  const [newThreadAnchor, setNewThreadAnchor] = useState<HTMLElement | null>(
    null
  );
  const theme = useTheme();
  const [removeThread, removeThreadResult] = useDeleteThreadMutation();
  const [deleteThreadId, setDeleteThreadId] = useState("");
  const [confirmationProps, setConfirmationProps] = useState({
    title: "",
    content: "",
    btn1: "",
    btn2: "",
    handleBtn1: () => {},
    handleBtn2: () => {},
    icon: <div></div>,
    bgcolor: "",
  });
  const llmIcon = (llm: string) => {
    switch (llm) {
      case "claude":
        return <RiClaudeFill color={theme.palette.primary.main} size={23} />;
      case "openai":
        return <RiOpenaiFill color={theme.palette.primary.main} size={23} />;
      case "deepseek":
        return (
          <DeepseekIcon
            className={
              theme.palette.mode == "light" ? "deepseek-light" : "deepseek-dark"
            }
          />
        );
    }
  };

  const formatTimeWithoutSeconds = (date: string | number | Date) => {
    return (
      new Date(date)
        .toLocaleTimeString()
        .slice(0, new Date(date).toLocaleTimeString().length - 6) +
      new Date(date)
        .toLocaleTimeString()
        .slice(new Date(date).toLocaleTimeString().length - 3)
    );
  };

  useEffect(() => {
    if (conversations.length && conversations.find((convo) => convo.selected)) {
      if (!personalThread) {
        setSelectedConversation(
          conversations.find((convo) => convo.selected).conversation_id
        );
      }
    }
  }, [JSON.stringify(conversations)]);

  const [pages, setPages] = useState([
    {
      icon: <IoSettingsOutline color={"#2a945f"} />,
      text: "Settings",
      path: "/settings",
      active: false,
      id: 1,
    },
    {
      icon: <TfiHelpAlt color={"#2a945f"} />,
      text: "Help",
      path: "/help",
      active: false,
      id: 2,
    },
  ]);
  const bgdefault = theme.palette.background.default;
  const mode = theme.palette.mode;

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("userInfo");
    dispatch(setUser({}));
    navigate("/signin");
  };

  function stringAvatar(name: string) {
    return {
      sx: {
        bgcolor: "#2a945f",
      },
      children: `${name.split(" ")[0][0]}${name.split(" ")[1][0]}`,
    };
  }

  const handleClose = () => {
    setNewThreadAnchor(null);
  };

  const deleteThreadFunc = async (id: string) => {
    const response: any = await removeThread(`?conversation_id=${id}`);
    if (response.error) {
      errorToast(
        response.error.error ||
          (response.error.data && response.error.data.message)
      );
    } else {
      setDeleteThreadId("");
      successToast("Thread has been deleted");
    }
  };

  const confirmDeleteThread = (id: string) => {
    setConfirmationProps({
      title: "WARNING",
      bgcolor: "rgba(180, 69, 52, 1)",
      content: "Are you sure you want to delete this thread?",
      btn1: "Cancel",
      btn2: "",
      handleBtn1: () => setDeleteThreadId(""),
      handleBtn2: () => confirmDeleteThread(id),
      icon: <div></div>,
    });
    deleteThreadFunc(id);
  };

  const deleteThread = (id: string, event: any) => {
    event.stopPropagation();
    setDeleteThreadId(id);
    setConfirmationProps({
      title: "WARNING",
      bgcolor: "rgba(180, 69, 52, 1)",
      content: "Are you sure you want to delete this thread?",
      btn1: "Cancel",
      btn2: "Proceed",
      handleBtn1: () => setDeleteThreadId(""),
      handleBtn2: () => confirmDeleteThread(id),
      icon: <div></div>,
    });
  };

  return (
    <div className="toolbar-bg" style={{ backgroundColor: bgdefault }}>
      <Toolbar className="toolbar">
        <div className="toolbar-header">
          <img
            src={NavbarLogo}
            className="navbar-logo"
            onClick={() => navigate("/chat")}
          />
        </div>
      </Toolbar>
      <Divider
        sx={{ margin: "20px 10px 10px 10px", backgroundColor: "#2a945f" }}
      />
      <div className="new-thread">
        <CustomButton
          text={"Start new thread"}
          startIcon={
            <IoChatbubbleEllipsesOutline color={theme.palette.primary.main} />
          }
          submit={(event: React.MouseEvent<HTMLButtonElement>) => {
            // setSelectedConversation("");
            // navigate("/chat");
            setNewThreadAnchor(event.currentTarget);
          }}
          color={theme.palette.primary.main}
          bgcolor="rgba(52, 180, 116, 0.25)"
          height="45px"
          width="100%"
          borderRadius="10px"
        />
      </div>
      {newThreadAnchor ? (
        <ManageThread
          anchor={newThreadAnchor}
          onClose={handleClose}
          setManageSummary={() => console.log("")}
        />
      ) : null}
      {conversations && conversations.length ? (
        <div
          className="conversations"
          style={{
            height:
              subscriptionStatus && subscriptionStatus != "Freemium"
                ? "calc(100vh - 240px)"
                : "calc(100vh - 420px)",
          }}
        >
          <Typography sx={{ color: "#2a945f", margin: "10px" }}>
            Threads
          </Typography>
          {conversations
            .filter((convo) => convo.status == "active")
            .map((convo: any, i) => {
              return convo.lastMessage ? (
                <div
                  key={i}
                  className="convo"
                  style={{
                    backgroundColor:
                      selectedConversation == convo.conversation_id
                        ? "rgba(52, 180, 116, 0.25)"
                        : "initial",
                    border:
                      selectedConversation == convo.conversation_id
                        ? "none"
                        : "1px solid #2a945f7e",
                  }}
                  onClick={() => {
                    if (personalThread) {
                      dispatch(setUser({ personalThread: false }));
                    }
                    setSelectedConversation(convo.conversation_id);
                    navigate(`/chat?conversation_id=${convo.conversation_id}`);
                  }}
                >
                  <div>
                    {convo.metadata ? (
                      <div className="convo-head">
                        <Typography
                          className="convo-name"
                          fontSize={12}
                          sx={{ fontWeight: "600 !important" }}
                          color="secondary"
                        >
                          {convo.metadata.generated_name}{" "}
                        </Typography>
                        <div>
                          <FaRegTrashCan
                            className="convo-delete"
                            color="rgba(180, 69, 52, 1)"
                            onClick={(event: any) =>
                              deleteThread(convo.conversation_id, event)
                            }
                          />
                        </div>
                      </div>
                    ) : null}
                    <Typography
                      className="convo-msg"
                      fontSize={12}
                      sx={{ fontWeight: "400 !important", marginTop: "5px" }}
                      color="secondary"
                    >
                      {convo.lastMessage.includes(
                        "https://hiibo-image-storage.s3"
                      ) ? (
                        <div className="img-preview">
                          <img
                            src={Picture}
                            style={{
                              width: "18px",
                              height: "18px",
                              opacity: "0.9",
                            }}
                          />{" "}
                          Image generated
                        </div>
                      ) : (
                        convo.lastMessage.slice(0, 50)
                      )}
                      {convo.lastMessage.includes(
                        "https://hiibo-image-storage.s3"
                      )
                        ? ""
                        : convo.lastMessage.length == 50
                        ? "..."
                        : ""}
                    </Typography>
                    <div
                      className="convo-time"
                      style={{
                        color:
                          selectedConversation == convo.conversation_id
                            ? "initial"
                            : theme.palette.primary.main,
                      }}
                    >
                      {new Date(
                        convo.lastMessageTimestamp
                      ).toLocaleDateString()}{" "}
                      {formatTimeWithoutSeconds(convo.lastMessageTimestamp)}
                      <div>
                        {convo.metadata
                          ? llmIcon(convo.metadata.llm_choice)
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null;
            })}
        </div>
      ) : null}
      <Box
        className="personal-thread-btn"
        sx={{
          position: "absolute",
          bottom:
            subscriptionStatus && subscriptionStatus == "Freemium"
              ? "196px"
              : "20px",
          cursor: personalThread ? "auto" : "pointer",
          opacity: personalThread ? "0.5" : "1",
        }}
        onClick={() => {
          if (!personalThread) {
            navigate("/chat?conversation_id=" + personal_thread_id);
            // dispatch(setConversations([]));
            setSelectedConversation(personal_thread_id);
            dispatch(setUser({ personalThread: !personalThread }));
          }
        }}
      >
        <div className="personal-info">
          <Typography className="user-firstname">{firstName}</Typography>
          <div className="my-thread">My thread</div>
        </div>
        <div className="personal-actions">
          <div className="personal-action">{llmIcon(personal_thread_llm)}</div>
          {/* <div className="personal-action">
            <FaRegTrashCan
              className="convo-delete"
              color="rgba(180, 69, 52, 1)"
            />
          </div> */}
        </div>
      </Box>
      {subscriptionStatus && subscriptionStatus == "Freemium" ? (
        <Box className="upgrade-tokens">
          <p>
            Running low on tokens? Get 20,000 tokens/month with Alpha and keep
            the convo going.
          </p>
          <div
            className="upgrade-btn"
            onClick={() =>
              (window.location.href = paymentLinks.find(
                (payment: { name: string | string[] }) =>
                  payment.name.includes("Alpha Access")
              ).url)
            }
          >
            <CustomButton
              text="Upgrade Now"
              borderRadius="10px"
              bgcolor="#218F54"
              color="white"
              width="100%"
            />
          </div>
        </Box>
      ) : null}
      {deleteThreadId ? (
        <ConfirmationDialog
          open={deleteThreadId ? true : false}
          content={confirmationProps.content}
          title={confirmationProps.title}
          btn1={confirmationProps.btn1}
          btn2={confirmationProps.btn2}
          handleBtn1={confirmationProps.handleBtn1}
          handleBtn2={confirmationProps.handleBtn2}
          icon={confirmationProps.icon}
          bgcolor={confirmationProps.bgcolor}
        />
      ) : null}
    </div>
  );
};
